/**
 * Just a helper to simplify management of the DOM selectors in the app
 */
export type ElementSelector =
  | { testId: string }
  | { selector: string }
  | { xpath: string };

export function queryElement(selector: ElementSelector): HTMLElement | null {
  if ('testId' in selector) {
    return window.document.querySelector(`[data-testid="${selector.testId}"]`);
  }

  if ('selector' in selector) {
    return window.document.querySelector(selector.selector);
  }

  if ('xpath' in selector) {
    return document.evaluate(
      selector.xpath,
      document,
      null,
      XPathResult.FIRST_ORDERED_NODE_TYPE,
      null
    ).singleNodeValue as HTMLElement | null;
  }

  throw new Error('Unknown selector.');
}
